import App from '@/models/App'

export default class TrafficShipScheduleComment extends App {
    static get entity() {
        return 'TrafficShipScheduleComments'
    }
    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }
    static fields() {
        return {
            id: this.attr(''),
            userId: this.attr(''),
            parentType: this.attr(''),
            parentId: this.attr(''),
            comment: this.attr(''),
            user: this.attr({}),
            isMine: this.attr(false),
            createdAt: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(trafficShipScheduleId, params) {
                return this.get(
                    `traffic/ship/schedules/${trafficShipScheduleId}/comments`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(trafficShipScheduleId, params) {
                return this.post(
                    `/traffic/ship/schedules/${trafficShipScheduleId}/comments`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(trafficShipScheduleId, trafficCommentId, params) {
                return this.patch(
                    `/traffic/ship/schedules/${trafficShipScheduleId}/comments/${trafficCommentId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficShipScheduleId, trafficCommentId) {
                return this.delete(
                    `traffic/ship/schedules/${trafficShipScheduleId}/comments/${trafficCommentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: trafficCommentId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
